// For TS use enum RoleStatuses (src/enums/RoleStatuses.ts)
export const Statuses = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING: "PENDING",
  DECEASED: "DECEASED",
  UNREGISTERED: "UNREGISTERED",
  ALL: "ALL",
  DRAFT: "DRAFT",
};

export const Genders = {
  FEMALE: "FEMALE",
  MALE: "MALE",
  MIXED: "MIXED",
  UNKNOWN: "UNKNOWN",
};

export const manageOfficialStatuses = [Statuses.ACTIVE, Statuses.PENDING, Statuses.INACTIVE];
